module.exports = __webpack_public_path__ + "img/20200512_163010.0c8327dc.jpg";